import {
  Box,
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuItemOption,
  MenuList,
  MenuOptionGroup,
} from '@chakra-ui/react';
import { SortIcon } from '../../config/icons';
import { ChevronDownIcon } from '@chakra-ui/icons';
import { RATINGS_MAP } from '../../config/constants';
import React, { FC, useContext } from 'react';
import { TermCategory } from '../../generated/types';
import { observer } from 'mobx-react-lite';
import SearchContext from '../../context/SearchContext';
import { autocompleteResultToUrl } from '../../utils/helper';
import { useRouter } from 'next/router';

interface SortFieldProps {
  category: TermCategory;
}

const SortField: FC<SortFieldProps> = ({ category }) => {
  const context = useContext(SearchContext);
  const router = useRouter();

  const onChangeSorting = (val: string) => {
    if (val && val.indexOf('__') !== -1) {
      const splitted = val.split('__');
      if (splitted.length === 2) {
        const url = autocompleteResultToUrl(
          category,
          null,
          context.form.radius ? context.form.radius : undefined,
          {
            filter: router.query.filter,
            latitude: router.query.latitude,
            longitude: router.query.longitude,
            query: router.query.query,
            radius: context.form.radius ? context.form.radius + '' : undefined,
            sort: splitted[0],
            sortOrder: splitted[1],
          }
        );

        if (url) {
          router.push(url);
        }
      }
    }
  };

  return (
    <Flex align={'center'} marginRight={2}>
      <Box fontSize={'lg'} marginRight={2} whiteSpace="nowrap">
        <SortIcon marginRight={1} />
        Sortiert nach:
      </Box>
      <Menu gutter={0} placement="bottom-end">
        <MenuButton
          size="sm"
          fontSize="lg"
          variant="unstyled"
          as={Button}
          rightIcon={<ChevronDownIcon />}
        >
          {RATINGS_MAP[context.form.sort]}
        </MenuButton>
        <MenuList fontSize="lg">
          <MenuOptionGroup
            onChange={onChangeSorting}
            defaultValue="asc"
            type="radio"
          >
            <MenuItemOption value="popularity__desc">
              Beliebtheit
            </MenuItemOption>
            {category.key === 'hotel' && (
              <MenuItemOption value="average_rating__desc">
                Beste Bewertung
              </MenuItemOption>
            )}
            {category.key === 'hotel' && (
              <MenuItemOption value="rating_count__desc">
                Am meisten Bewertungen
              </MenuItemOption>
            )}
            <MenuItemOption value="title__asc">Titel</MenuItemOption>
          </MenuOptionGroup>
        </MenuList>
      </Menu>
    </Flex>
  );
};

export default observer(SortField);
